import { Component, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { StoreSelectorsService } from "../../../../services/store-selectors.service";
import { MatDialog } from "@angular/material/dialog";
import { IBaseBlockComponent, ISendEvents } from "../../../../interfaces";
import { TranslocoService } from "@ngneat/transloco";
import { BlockBaseComponent } from "../block-base/block-base.component";
import { actionAddSceneItem, actionUpdateEventsStrings } from "../../../../store/actions/user.actions";
import { ButtonBarComponent, IButtonBar } from "../../../../components/add-remove-bar/button-bar.component";

@Component({
    selector: 'app-block-filter-events',
    templateUrl: './block-filter-events.component.html',
    styleUrls: ['./block-filter-events.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed, void', style({ height: '0px' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
            transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
        ]),
    ],
})
export class BlockFilterEventsComponent extends BlockBaseComponent implements IBaseBlockComponent {
    dataSource: Array<any> = [];
    displayedColumns: string[] = ['eventName', 'condition', 'field'];
    displayedColumnsWithEdit: string[] = ['eventName', 'condition', 'field', 'editIcon'];
    options;
    highlightedRows = [];
    buttons: IButtonBar[] = [];
    eventsAll: Array<string> = [];
    eventsAllFiltered: Array<string> = [];
    expandedElement = null;
    expandedIndex = null;

    @ViewChild('dtable') dtable: any;
    @ViewChild(ButtonBarComponent) addRemoveBarComponent: ButtonBarComponent;

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
        this.options = ['==', '>=', '<=', '!=', '<', '>', 'or', 'and', 'in'];
        this.buttons = [
            {
                callBack: v => (v),
                icon: 'add',
                name: 'add',
                disableByList: false,
                disabled: false,
                tooltip: '+'
            },
            {
                callBack: v => (v),
                icon: 'remove',
                name: 'remove',
                confirmRemove: this.translocoService.translate('toast.deleteConfirm', {}, this.translocoService.getActiveLang()),
                disableByList: true,
                disabled: false,
                tooltip: '-'
            },
        ];
        this.cod(
            this.storeSelector.getEventsCombined().subscribe((events) => {
                this.eventsAll = this.eventsAllFiltered = events;
            })
        );
    }

    override preInit() {
        super.preInit();
    }

    onAdd(v) {
        if (this.sceneItem.Data[0].Json?.[0].Filters?.[0]?.Filter && this.sceneItem.Data[0].Json?.[0].Filters[0].Filter.length > 0) {
            this.storeSelector.dispatch(actionAddSceneItem({
                sceneId: this.sceneId,
                sceneItemId: this.sceneItem.$.id,
                values: [{
                    key: 'Filter',
                    value: {
                        $: {
                            field: "name",
                            condition: ">=",
                            eventName: "value"
                        }
                    },
                    storePath: `Data[0].Json[0].Filters[0]`
                }]
            }));
        } else {
            this.dispatchSceneItemChanges({
                sceneId: this.sceneId,
                sceneItemId: this.sceneItem.$.id,
                values: [{
                    key: 'Filter',
                    value: [
                        {
                            $: {
                                field: "name",
                                condition: ">=",
                                eventName: "value"
                            }
                        }
                    ],
                    storePath: `Data[0].Json[0].Filters[0]`
                }]
            });
        }
    }

    onRemove(v) {
        if (this.highlightedRows.length === 0) return;
        const values: ISendEvents[] = [];
        this.highlightedRows.forEach((i_selected) => {
            this.dataSource.forEach((item, index) => {
                if (item === i_selected) return;
                values.push({
                    $: {
                        field: item.field,
                        condition: item.condition,
                        eventName: item.eventName
                    }
                });
            });
        });
        this.dispatchChanges(values);
    }

    dropdownOnSelectionChanged(event, i_item) {
        const values = [];
        this.dataSource.forEach((item, index) => {
            values.push({
                $: {
                    field: item.field,
                    condition: item === i_item ? event.value : item.condition,
                    eventName: item.eventName
                }
            });
        });
        this.dispatchChanges(values);
    }

    onFilter(event) {
        this.eventsAllFiltered = this.eventsAll.filter((a) => {
            return a.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1;
        });
    }

    updateInput(col, index: number, value, isCollapse = false) {
        const values = [];
        this.dataSource.forEach((item, counter) => {
            values.push({
                $: {
                    field: (col === 'field' && counter === index) ? value : item.field,
                    condition: item.condition,
                    eventName: (col === 'eventName' && counter === index) ? value : item.eventName
                }
            });
        });

        if (isCollapse) {
            this.collapseEditor();
        }

        // need settimeout when collapse the editor
        setTimeout(() => {
            this.dispatchChanges(values);
        }, 100);
    }

    onSelectedRow(row) {
        /** uncomment to support multi select **/
        /** this.highlightedRows.push(row) **/
        this.highlightedRows = [row];
        if (this.expandedElement !== row) {
            this.expandedElement = null;
        }
    }

    dispatchChanges(values) {
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'Filters',
                value: [{
                    "Filter": values
                }],
                storePath: `Data[0].Json[0]`
            }]
        });
    }

    dispatchEventsAll(eventsAll) {
        this.storeSelector.dispatch(actionUpdateEventsStrings({ eventsStrings: eventsAll }));
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [];
    }

    override initApplyStoreToDynamic(applyStoreToDynamic) {
        super.initApplyStoreToDynamic(applyStoreToDynamic);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
        this.dataSource = [];
        this.highlightedRows = [];
        const events = [];
        if (!this.sceneItem.Data[0].Json?.[0]?.Filters?.[0]?.Filter) return;
        this.sceneItem.Data[0].Json[0].Filters[0].Filter.forEach((v, ind) => {
            events.push(v.$.eventName);
            const row = { condition: v.$.condition, field: v.$.field, eventName: v.$.eventName };
            this.dataSource.push(row);
            if (this.expandedIndex === ind) {
                this.expandedElement = row;
            }
        });
        this.dispatchEventsAll(events);
    }

    override submit(formValues) {
        return super.submit(formValues);
    }

    expandEditor(element, index) {
        this.expandedElement = element;
        this.expandedIndex = index;
    }

    collapseEditor() {
        this.expandedElement = null;
        this.expandedIndex = null;
    }

    override destroy() {
        // Lib.DevShow('porthandler: destroy filter ' + Math.random());
        super.destroy();
    }
}

